"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.configLogin2FARoutes = exports.changeAuthorizationId = exports.changeUserConfirmedStatus = void 0;
const miragejs_1 = require("miragejs");
const uuid_1 = __importDefault(require("uuid"));
const constants_1 = require("@/features/login2fa/constants");
const configurations_1 = require("../../../data-manager/configurations");
let isUserConfirmed = false;
let authorizationId = '';
let prevAuthorizationId = '';
let authorizationStatusRetrieveRequestCounts = 0;
const AUTHORIZATION_STATUS_RETRIEVE_MAX_REQUEST = 100;
const AUTHORIZATION_STATUS_RETRIEVE_DELAY = 500; // ms
function changeUserConfirmedStatus(data) {
    isUserConfirmed = data;
}
exports.changeUserConfirmedStatus = changeUserConfirmedStatus;
function changeAuthorizationId() {
    authorizationId = uuid_1.default.v4();
}
exports.changeAuthorizationId = changeAuthorizationId;
function configLogin2FARoutes(server) {
    server.post((0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.TAC_VALIDATE, (schema, request) => {
        console.log('request: ', request);
        const requestData = JSON.parse(request.requestBody);
        if (requestData.otp === '111111') {
            if (request.requestHeaders['x-acc-op'].startsWith('verify')) {
                return new miragejs_1.Response(200, {}, {
                    status: 'SUCCESS',
                    data: {}
                });
            }
            else {
                return new miragejs_1.Response(200, {}, {
                    status: 'SUCCESS',
                    data: {
                        authorizationId: 'ea769682-667b-41c7-9b0a-7a8025694349',
                        transactionId: '74d920d0-e362-4c09-b0a5-b063de485fb6',
                        notifySoftToken: 1,
                        maskedMobileNo: '+XXXXXX2542',
                        tokens: [
                            {
                                tokenSerialNo: 'VK7ZF2E9F367'
                            }
                        ],
                        authorizationTypeCode: 'SWK',
                        authorizationReference: 'QhRe',
                        challengeCode: '717456',
                        availableAuthorizationTypeCode: 'SWK,HWK'
                    }
                });
            }
        }
        else if (requestData.otp === '000000') {
            return new miragejs_1.Response(200, {}, {
                status: 'FAILED',
                errorCode: 'CAUTH-20058',
                description: 'Verify tac failure wrong OTP format'
            });
        }
        else if (requestData.otp === '222222') {
            return new miragejs_1.Response(200, {}, {
                status: 'FAILED',
                errorCode: 'CAUTH-20058',
                description: 'Verify tac failure 19999/Verify tac failure 999/...'
            });
        }
        else if (requestData.otp === '333333') {
            return new miragejs_1.Response(200, {}, {
                status: 'FAILED',
                errorCode: 'CAUTH-20012',
                description: 'Exceed Maximum Retry'
            });
        }
    });
    server.post((0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.ACCESS_ELEVATION_REQUEST, (schema, request) => {
        console.log('params:', request.requestBody);
        //const requestData = JSON.parse(request.requestBody) as IAccessElevationReqRequest
        //const mockTriggerOTPYesError = false && requestData.triggerOTP === 'Yes'
        //const mockTriggerOTPNoError = false && requestData.triggerOTP === 'No'
        const mockTriggerOTPYesError = false;
        const mockTriggerOTPNoError = false;
        authorizationStatusRetrieveRequestCounts = 0;
        if (mockTriggerOTPYesError || mockTriggerOTPNoError) {
            return new miragejs_1.Response(200, {}, {
                status: 'FAILED'
            }
            // }
            // {
            //   status: ACCESS_ELEVATION_REQUEST_STRATUS.ELEVATION_REQUEST_FAILED,
            //   errorCode: ACCESS_ELEVATION_REQUEST_ERROR_CODE.TOKENVALIDATION,
            // }
            );
        }
        changeAuthorizationId();
        return new miragejs_1.Response(200, {}, {
            status: 'SUCCESS',
            data: {
                status: '',
                authorizationId,
                authorizationTypeCode: '',
                authorizationReference: '',
                transactionId: authorizationId,
                maskedMobileNo: '+XXXXXX4135',
                triggerOTP: '',
                availableAuthorizationTypeCode: '',
                notifySoftToken: ''
            }
        });
        // return new Response(500, {}, {});
    });
    server.post((0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.ACCESS_ELEVATION_VALIDATE, (schema, request) => {
        console.log('params:', request.requestBody);
        const requestData = JSON.parse(request.requestBody);
        if (requestData.otp.startsWith('400')) {
            return new miragejs_1.Response(400, {}, {
                key4001: 'value4001',
                key4002: 'value4002'
            });
        }
        else if (requestData.otp.startsWith('500')) {
            return new miragejs_1.Response(500, {}, {
                key5001: 'value5001',
                key5002: 'value5002'
            });
        }
        else if (requestData.otp === '111111') {
            return new miragejs_1.Response(200, {}, {
                status: constants_1.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_SUCCESS
            });
        }
        else if (requestData.otp === '222222') {
            return new miragejs_1.Response(200, {}, {
                status: constants_1.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_FAILED,
                errorCode: constants_1.ACCESS_ELEVATION_VALIDATE_ERROR_CODE.WRONG_OTP
            });
        }
        else if (requestData.otp === '333333') {
            return new miragejs_1.Response(200, {}, {
                status: constants_1.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_FAILED,
                errorCode: constants_1.ACCESS_ELEVATION_VALIDATE_ERROR_CODE.EXCEED_MAXIMUM_RETRY
            });
        }
        // fallback to success
        return new miragejs_1.Response(200, {}, {
            status: constants_1.ACCESS_ELEVATION_VALIDATE_STRATUS.ELEVATION_FAILED
        });
    });
    server.post((0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.MFA_SEND_OTP, (schema, request) => {
        console.log('params:', request.requestBody);
        //const requestData = JSON.parse(request.requestBody) as IMfa_SendOtpRequest
        const mockError = false;
        authorizationStatusRetrieveRequestCounts = 0;
        if (mockError) {
            return new miragejs_1.Response(200, {}, {
                status: 'FAILED'
            });
        }
        changeAuthorizationId();
        return new miragejs_1.Response(200, {}, {
            status: 'SUCCESS',
            data: {
                status: 'NO_TAC_REQUIRED/TAC_REQUIRED',
                transactionId: authorizationId,
                authorizationId,
                authorizationTypeCode: '',
                authorizationReference: '',
                triggerOTP: '',
                notifySoftToken: '',
                challengeCode: '097856',
                availableAuthorizationTypeCode: '',
                tokens: [
                    {
                        tokenSerialNo: ''
                    }
                ]
            }
        });
        // return new Response(500, {}, {});
    });
    server.post((0, configurations_1.getServer)().CUSTOMER_AUTHORIZATION + configurations_1.PATH.TAC_AUTHORIZATION_STATUS_RETRIEVE, (schema, request) => {
        const requestData = JSON.parse(request.requestBody);
        console.log('active authorizationId      : ', authorizationId);
        console.log('request inpu authorizationId: ', requestData === null || requestData === void 0 ? void 0 : requestData.authorizationId);
        if ((requestData === null || requestData === void 0 ? void 0 : requestData.authorizationId) !== prevAuthorizationId) {
            authorizationStatusRetrieveRequestCounts = 0;
            prevAuthorizationId = requestData === null || requestData === void 0 ? void 0 : requestData.authorizationId;
            console.log('prevAuthorizationId updated to requestData');
        }
        if ((requestData === null || requestData === void 0 ? void 0 : requestData.authorizationId) === prevAuthorizationId) {
            console.log('authorizationId is the same as requestData');
            authorizationStatusRetrieveRequestCounts++;
            if (authorizationStatusRetrieveRequestCounts === 10) {
                changeUserConfirmedStatus(true);
            }
            console.log('current counts:', authorizationStatusRetrieveRequestCounts, 'max:', AUTHORIZATION_STATUS_RETRIEVE_MAX_REQUEST);
            if (isUserConfirmed || authorizationStatusRetrieveRequestCounts === AUTHORIZATION_STATUS_RETRIEVE_MAX_REQUEST) {
                // mock user input delay(not exactly really)
                authorizationStatusRetrieveRequestCounts = 0;
                changeUserConfirmedStatus(false);
                return new miragejs_1.Response(200, {}, {
                    status: 'SUCCESS'
                });
            }
            else {
                return new miragejs_1.Response(200, {}, {
                    status: 'PENDING'
                });
            }
        }
        else {
            return new miragejs_1.Response(200, {}, {
                status: 'FAILED'
            });
        }
        // return new Response(500, {}, {});
    }, { timing: AUTHORIZATION_STATUS_RETRIEVE_DELAY });
    return server;
}
exports.configLogin2FARoutes = configLogin2FARoutes;
exports.default = configLogin2FARoutes;
